"use strict";

exports.__esModule = true;
exports.PlaybackPolicy = void 0;
var _XmlValidation2 = require("../Parsers/XmlValidation");
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
/**
 * PlaybackPolicy declares a set of methods that provide playback policy decisions to the app.
 *
 * It is implemented by the Session-derived instance, which delegates calls to a policy adapter - if one
 * is attached. This allows the business logic of playback policy to be implemented in a single place.
 * @hideconstructor
 */
var PlaybackPolicy = /*#__PURE__*/function (_XmlValidation) {
  _inheritsLoose(PlaybackPolicy, _XmlValidation);
  function PlaybackPolicy() {
    return _XmlValidation.apply(this, arguments) || this;
  }
  var _proto = PlaybackPolicy.prototype;
  /** Returns to the client whether playback can stop.
   * If a custom implemented playback policy handler is not set on the session, a default value of
   * `true` is returned.
   * 
   * @return {boolean} true if playback can stop, false otherwise.
   */
  _proto.canStop = function canStop() {
    throw new Error("Function must be overridden");
  }

  /** Returns to the client whether playback can pause.
   * If a custom implemented playback policy handler is not set on the session, a default value of
   * `false` for Live,
   * `true` for other playback modes
   *  is returned.
   * 
   * @return {boolean} true if playback can pause, false otherwise.
   */;
  _proto.canPause = function canPause() {
    throw new Error("Function must be overridden");
  }

  /** Returns to the client whether playback can skip.
   * If a custom implemented playback policy handler is not set on the session, a default value of
   * `-1` for Live and `0` for other playback modes is returned.
   * 
   * @return {number} delay in seconds before the advert can be skipped, or -1 otherwise.
   */;
  _proto.canSkip = function canSkip() {
    throw new Error("Function must be overridden");
  }

  /** Returns to the client the playhead position that the user can seek to.
   * If a custom implemented playback policy handler is not set on the session,
   * the current playhead position is returned for Live and the seek position is returned for other playback modes.
   * 
   * @param {number} position the playhead position, in milliseconds, that the user wishes to seek to
   * @return {number} the actual playhead position, in milliseconds, that the user can seek to, based on the implemented policy.
   */;
  _proto.willSeekTo = function willSeekTo(position) {
    throw new Error("Function must be overridden");
  }

  /** Returns to the client whether volume can be muted.
   * If a custom implemented playback policy handler is not set on the session, a default value of
   * `true` is returned.
   * 
   * @param {boolean} mute The intended volume change: muted or unmuted
   * @return {boolean} true if volume can be muted, false otherwise.
   */;
  _proto.canChangeVolume = function canChangeVolume(mute) {
    throw new Error("Function must be overridden");
  }

  /** Returns to the client whether full screen mode can change.
   * If a custom implemented playback policy handler is not set on the session, a default value of
   * `true` is returned.
   * 
   * @param {boolean} fullScreen The intended resize mode
   * @return {boolean} true if full screen mode can change, false otherwise.
   */;
  _proto.canResize = function canResize(fullScreen) {
    throw new Error("Function must be overridden");
  }

  /** Returns to the client whether the currently-displayed linear creative can be resized.
   * Note that this method is not applicable to nonlinear creative.
   * If a custom implemented playback policy handler is not set on the session, a default value of
   * `true` is returned.
   * 
   * @param {boolean} expand whether to expand the creative or collapse it
   * @return {boolean} true if the creative can be resized, false otherwise.
   */;
  _proto.canResizeCreative = function canResizeCreative(expand) {
    throw new Error("Function must be overridden");
  }

  /** Returns to the client whether the user can click-through.
   * If a custom implemented playback policy handler is not set on the session, a default value of
   * `true` is returned.
   *
   * @param {string} url The click-through Url.
   * @return {boolean} true if the user can click through, false otherwise.
   */;
  _proto.canClickThrough = function canClickThrough(url) {
    throw new Error("Function must be overridden");
  };
  return PlaybackPolicy;
}(_XmlValidation2.XmlValidation);
exports.PlaybackPolicy = PlaybackPolicy;